<template>
  <transition name="fade" mode="out-in">
    <div v-if="isAuthenticated" class="app-container">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" :key="$route.fullPath" @formDataActionCalled="formDataActionCalled" @definitionError="definitionError" />
        </transition>
      </router-view>
      <transition name="fade" mode="out-in">
        <div v-if="errorMsg" class="popup">
          <div class="w3-modal" @click.prevent>
            <div class="w3-modal-content definition-error">
              <simplebar data-simplebar-auto-hide="false">
                <div class="container">
                  <div>
                    <span class="w3-display-topright close_detail"><i class="sherpa-icon icon-cerrar" @click="popupClose()"></i></span>
                    <div class="w3-container">
                      <div class="w3-row popup-content">
                        <i class="sherpa-icon icon-ico_error"></i> {{ errorMsg }}
                      </div>
                    </div>
                  </div>
                </div>
              </simplebar>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import menu from '@/utils/menu'
import * as appTypes from '@/store/actions/app'
import * as authTypes from '@/store/actions/auth'
import simplebar from 'simplebar-vue'
import 'simplebar-core/dist/simplebar.css'

export default {
  name: 'container',
  props: [
    'type',
    'content'
  ],
  data () {
    return {
      errorMsg: null
    }
  },
  components: {
    simplebar
  },
  mounted () {
  },
  methods: {
    formDataActionCalled (stay) {
      if (!stay) {
        this.goToParentMenu()
      }
    },
    goToParentMenu () {
      var path = this.$route.matched[this.$route.matched.length - 1].path
      var menuParent = menu.methods.getDefaultParentMenuPath(null, this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`], path)
      this.$router.push(menuParent.parentContextPath + menuParent.contextPath).catch(() => {})
    },
    definitionError (error, resultError, container) {
      if (error && resultError) {
        this.errorMsg = resultError.requestErrorMsg
      }
    },
    popupClose () {
      this.errorMsg = null
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`])
  }
}
</script>

<style lang="scss">
#content {
  > .app-container {
    > .container-simplebar {
      position: absolute;
      top: 106px;
      bottom: 62px;
      right: 18px;
      left: 118px;
    }
  }
}
</style>
